import Box from '@mui/material/Box';
import { PropsWithChildren } from 'react';

import * as loadingOnFrontStyles from './LoadingOnFront.styles';

// import Loading from '../../../Loading';

export interface LoadingOnFrontProps {
  isLoading: boolean;
}

function LoadingOnFront({ children, isLoading }: PropsWithChildren<LoadingOnFrontProps>) {
  const { classes: loadingClasses } = loadingOnFrontStyles.useLoadingStyles();

  return (
    <>
      <Box display="flex" flexDirection="column" flex={1} className={isLoading ? loadingClasses.hidden : ''}>
        {children}
      </Box>
      {/* {isLoading && (
        <Box height="50vh" display="flex" alignContent="center" justifyContent="center">
          <Loading />
        </Box>
      )} */}
    </>
  );
}

export default LoadingOnFront;
